import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';
import HeaderMetaTags from '~/components/modules/Header/HeaderMetaTags';

import { TrackRecordPageDark } from '~/components/views/TrackRecord/TrackRecordPageDark';

const AppContainer = dynamic(() => import('~/containers/AppContainer/AppContainer'));

const TrackRecord: React.FC = () => {
    const router = useRouter();
    return (
        <AppContainer>
            <HeaderMetaTags
                url={`${process.env.NEXT_PUBLIC_HOST_ENV}${router.asPath}`}
                title={'Wine and Whiskey Historical Performance - Investment | Vinovest'}
                description={
                    'Get historical performance investing data on Wine and Whiskey. Get data-drivien insights to help inform you of your next investments on Vinovest.'
                }
                canonical
            />
            <TrackRecordPageDark />
        </AppContainer>
    );
};

export default TrackRecord;
